import React, { Component } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import ExportPdfButton from './ExportPdfButton';

export default class FlagsActions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectFlagsBtn: {
        isActive: false
      }
    };
  }

  handleSelectionFlagsBtn = () => {
    this.props.handleFlagSelectionActionBtn();
    this.setState({
      selectFlagsBtn: { isActive: !this.state.selectFlagsBtn.isActive }
    });
  };

  handleExpandViewBtnAction = () => {
    this.props.handleExpandView();
  };

  expandViewButton = () => {
    return (
      <div style={{width: 12}}></div>
      // <Button
      //   onClick={this.handleExpandViewBtnAction}
      //   id="flags-actions-expand"
      //   className="flags-actions__btn-expand flags-actions-btn"
      // >
      //   <span className="btn-expand__title">
      //     {this.props.isExpandedView ? 'Standard View' : 'Expand View'}
      //   </span>
      //   {this.props.isExpandedView ? (
      //     <i className="fa fa-window-minimize" aria-hidden="true" />
      //   ) : (
      //     <i className="fa fa-arrows-alt" aria-hidden="true" />
      //   )}
      // </Button>
    );
  };

  selectSingleOrMultipleFlags = () => {
    return (
      <Button
        onClick={this.handleSelectionFlagsBtn}
        id="flags-actions-select-flags"
        className={`flags-actions__btn-select-flags flags-actions-btn${
          this.state.selectFlagsBtn.isActive ? ' is_active' : ''
        }`}
      >
        <i className="fa fa-circle-o" aria-hidden="true"></i>
        <span className="btn-select-flags__title">{`Select Flag(s)`}</span>
      </Button>
    );
  };

  render() {
    return (
      <Row>
        <Col xs={12}>
          <div className="flags-actions__wrapper">
            <div className="flags-actions__block flags-actions__block--left">
              <ExportPdfButton onExport={this.props.export} />
            </div>
            <div className="flags-actions__block flags-actions__block--right">
              {this.expandViewButton()}
              {this.selectSingleOrMultipleFlags()}
            </div>
          </div>
        </Col>
      </Row>
    );
  }
}
